import { apiGet } from "utils/apiClient";

export interface DollarQuote {
    casa: string;
    compra: number;
    venta: number;
    fecha: string;
}

export const DOLLAR_TYPES = ["oficial", "blue", "bolsa", "cripto"] as const;
export type DollarType = (typeof DOLLAR_TYPES)[number];

export async function fetchLatestRates(): Promise<Record<DollarType, DollarQuote>> {
    return apiGet<Record<DollarType, DollarQuote>>("/market/dollar-rates");
}

export async function fetchDollarBolsaReferenceRate(): Promise<DollarQuote> {
    const rates = await fetchLatestRates();
    return rates.bolsa;
}

export async function fetchHistoricalRates(type: DollarType): Promise<DollarQuote[]> {
    return apiGet<DollarQuote[]>(`/market/dollar-rates/${type}/history`);
}
